/* GET THE LOOK — quick-shop drawer. Web component <get-the-look>.
   Otwiera drawer z pozycjami zestawu; wybór rozmiaru inline; ADD TO BAG AJAX
   (Section Rendering API jak natywny Horizon) z odświeżeniem cart drawera + licznika;
   Size Guide per produkt w popoverze. */
class GetTheLook extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('[data-gtl-dialog]');
    this.sgDialog = this.querySelector('[data-gtl-sg-dialog]');
    this.sgBody = this.querySelector('[data-gtl-sg-body]');
    this.selected = new WeakMap(); // item -> variantId

    this.querySelector('[data-gtl-open]')?.addEventListener('click', () => this.open(this.dialog));
    this.querySelector('[data-gtl-close]')?.addEventListener('click', () => this.dialog?.close());
    this.querySelector('[data-gtl-sg-close]')?.addEventListener('click', () => this.sgDialog?.close());

    // klik w tło (backdrop) zamyka
    [this.dialog, this.sgDialog].forEach((d) => {
      d?.addEventListener('click', (e) => { if (e.target === d) d.close(); });
    });

    this.querySelectorAll('[data-gtl-item]').forEach((item) => this.bindItem(item));
  }

  open(dialog) {
    if (!dialog) return;
    if (dialog.showModal) dialog.showModal();
    else dialog.setAttribute('open', '');
  }

  bindItem(item) {
    const sizes = item.querySelectorAll('.gg-gtl__size');
    const addBtn = item.querySelector('[data-gtl-add]');
    // Produkt bez rozmiarów (jeden wariant, np. rękawiczki) — gotowy do dodania od razu.
    if (addBtn?.dataset.gtlVariant) this.selected.set(item, addBtn.dataset.gtlVariant);
    sizes.forEach((btn) => {
      if (btn.disabled) return;
      btn.addEventListener('click', () => {
        sizes.forEach((b) => b.classList.remove('gg-gtl__size--active'));
        btn.classList.add('gg-gtl__size--active');
        this.selected.set(item, btn.dataset.variantId);
        if (addBtn) addBtn.disabled = false;
      });
    });
    addBtn?.addEventListener('click', () => this.addToCart(item, addBtn));
    item.querySelector('[data-gtl-sizeguide]')?.addEventListener('click', () => this.openSizeGuide(item));
  }

  openSizeGuide(item) {
    const tpl = item.querySelector('[data-gtl-sizechart]');
    if (!tpl || !this.sgBody || !this.sgDialog) return;
    this.sgBody.innerHTML = tpl.innerHTML;
    this.open(this.sgDialog);
  }

  async addToCart(item, btn) {
    const variantId = this.selected.get(item);
    if (!variantId) return;
    const label = btn.querySelector('[data-gtl-add-label]');
    const orig = label ? label.textContent : '';
    btn.disabled = true;
    btn.classList.add('is-loading');

    const sectionIds = new Set();
    document.querySelectorAll('cart-items-component[data-section-id]').forEach((c) => sectionIds.add(c.dataset.sectionId));

    try {
      const body = { items: [{ id: variantId, quantity: 1 }] };
      if (sectionIds.size) body.sections = Array.from(sectionIds).join(',');

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      if (!res.ok) throw new Error('add failed');
      const data = await res.json();

      // Odśwież zawartość cart drawera (Section Rendering API) — bez reloadu, dialog GTL zostaje otwarty.
      if (data.sections) {
        for (const [, html] of Object.entries(data.sections)) {
          if (!html) continue;
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const freshInner = doc.querySelector('.cart-drawer__inner');
          const liveInner = document.querySelector('.cart-drawer__inner');
          if (freshInner && liveInner) { liveInner.innerHTML = freshInner.innerHTML; break; }
        }
      }

      // Licznik + widoczność bubble
      const cart = await fetch('/cart.js').then((r) => r.json());
      document.querySelectorAll('.cart-bubble').forEach((b) => {
        const el = b.querySelector('[data-cart-count]') || b;
        if (el) el.textContent = cart.item_count;
        b.classList.toggle('visually-hidden', cart.item_count === 0);
      });

      // Stan "dodano"
      btn.classList.remove('is-loading');
      btn.classList.add('is-added');
      if (label) label.textContent = btn.dataset.added || 'Added';
      setTimeout(() => {
        btn.classList.remove('is-added');
        if (label) label.textContent = orig;
        btn.disabled = false;
      }, 2200);
    } catch (e) {
      btn.classList.remove('is-loading');
      btn.disabled = false;
    }
  }
}

if (!customElements.get('get-the-look')) {
  customElements.define('get-the-look', GetTheLook);
}
